import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  adWrapper: (isListView?: boolean) => FelaCSS;
  imgWrapper: FelaCSS;
  img: FelaCSS;
  appBanner: FelaCSS;
  newFeaturePill: FelaCSS;
  adTitle: FelaCSS;
  adSubtitle: FelaCSS;
  reviewContainer: FelaCSS;
  reviewsAmount: FelaCSS;
  star: FelaCSS;
}

const styles = (): IStyles => ({
  newFeaturePill: {
    backgroundColor: colors.indigoCrush60,
    color: colors.white,
    borderRadius: '4px',
    fontDefault: 12,
    paddingVertical: 1,
    paddingHorizontal: 4,
    marginTop: 4,
    marginLeft: 6,
  },
  adTitle: {
    marginTop: 2,
    marginHorizontal: 2,
    fontDefaultSemiBold: 18,
    textAlign: 'center',
  },
  adSubtitle: {
    marginVertical: 2,
    marginLeft: 6,
    lineHeight: '24px',
  },
  adWrapper: (isListView) => ({
    marginTop: 12,
    alignItems: 'flex-start',
    backgroundColor: colors.indigoCrush04,
    borderRadius: 16,
    border: `1px solid ${colors.indigoCrush20}`,
    paddingVertical: 8,
    maxWidthMobile: {
      paddingHorizontal: 4,
      ...(isListView ? { marginHorizontal: 4 } : { marginRight: 4 }),
    },
  }),
  imgWrapper: {
    alignItems: 'center',
    marginVertical: 4,
    width: '100%',
  },
  img: {
    width: '80%',
  },
  appBanner: {
    marginTop: 6,
    width: '70%',
  },
  reviewContainer: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
    marginBottom: 4,
    gap: 20,
  },
  reviewsAmount: {
    fontDefaultSemiBold: 16,
  },
  star: {
    width: 20,
  },
});

export default styles;
